import { render } from "./LeftSidebarContentCenter.vue?vue&type=template&id=70004906&scoped=true"
import script from "./LeftSidebarContentCenter.vue?vue&type=script&lang=js"
export * from "./LeftSidebarContentCenter.vue?vue&type=script&lang=js"

import "./LeftSidebarContentCenter.vue?vue&type=style&index=0&id=70004906&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70004906"]])

export default __exports__